import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { PATH_DIRECT_PLACEMENTS } from '@/lib/constants/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const directPlacements = {
  namespaced: true,
  state: buildInitialState({
    directPlacementList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setDirectPlacements: (state, directPlacements) => {
      state.directPlacementList = directPlacements
    }
  },
  actions: {
    getDirectPlacementsWithFilters ({ dispatch, rootGetters }) {
      return dispatch('getDirectPlacements', { ...rootGetters['directPlacementFilters/getSearchObject'] })
    },
    getDirectPlacements: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting permanent placements, please wait...' })

      return api.doGet({ path: PATH_DIRECT_PLACEMENTS, parameters: filters })
        .then(json => json.data)
        .then(directPlacements => {
          commit('updateStatus', { status: COMPLETE })
          commit('setDirectPlacements', directPlacements)
          return directPlacements
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to select permanent placements')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default directPlacements
